import script from "./DashboardSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardSelector.vue?vue&type=script&setup=true&lang=js"

import "./DashboardSelector.vue?vue&type=style&index=0&id=6f1606f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f1606f8"]])

export default __exports__